// @ts-nocheck
import React, { useState } from 'react';
import { getMilestoneMessage, getExtensionDays } from '../utils/achievementUtils';

const EXTENSION_LABEL = { '30': '+1 month added', '60': '+2 months added', '100': '+6 months added' };

export default function AchievementModal({ milestone, onDismiss }) {
  const { title, body } = getMilestoneMessage(milestone);
  const extensionLabel = EXTENSION_LABEL[milestone] ?? '';
  const [sharing, setSharing] = useState(false);

  const handleShare = async () => {
    setSharing(true);
    try {
      await navigator.share({
        title: `Mokshapatra: ${title}`,
        text: `${body} ${extensionLabel}`,
      });
    } catch (_) {
      // User cancelled or share not supported
    } finally {
      setSharing(false);
    }
  };

  return (
    <>
      <div style={styles.overlay}>
        <div style={styles.card}>
          <div style={styles.daysCircle}>
            <span style={styles.daysNum}>{milestone}</span>
            <span style={styles.daysLabel}>days</span>
          </div>

          <h2 style={styles.title}>{title}</h2>
          <p style={styles.body}>{body}</p>

          <div style={styles.rewardBox}>
            <span style={styles.rewardText}>{extensionLabel} to your journey</span>
          </div>

          {'share' in navigator && (
            <button
              style={{ ...styles.shareBtn, opacity: sharing ? 0.6 : 1 }}
              onClick={handleShare}
              disabled={sharing}
            >
              Share this milestone
            </button>
          )}

          <button style={styles.dismissBtn} onClick={onDismiss}>
            Continue your practice
          </button>
        </div>
      </div>

      <style>{`@keyframes scaleIn { from{opacity:0;transform:scale(0.9)} to{opacity:1;transform:scale(1)} }`}</style>
    </>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0,
    background: 'rgba(13,13,43,0.95)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 10000, padding: '20px',
  },
  card: {
    background: '#1E1145', border: '1px solid rgba(201,146,10,0.4)',
    borderRadius: '24px', padding: '48px 36px',
    maxWidth: '400px', width: '100%', textAlign: 'center',
    boxShadow: '0 0 60px rgba(201,146,10,0.15), 0 20px 60px rgba(0,0,0,0.6)',
    animation: 'scaleIn 0.4s cubic-bezier(0.4,0,0.2,1)',
  },

  daysCircle: {
    width: '90px', height: '90px', borderRadius: '50%',
    background: 'rgba(201,146,10,0.12)', border: '2px solid rgba(201,146,10,0.4)',
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    margin: '0 auto 24px',
  },
  daysNum: { fontFamily: '"Cinzel", serif', fontSize: '28px', fontWeight: '700', color: '#C9920A', lineHeight: 1 },
  daysLabel: { fontSize: '11px', color: 'rgba(245,240,232,0.5)', letterSpacing: '1px', marginTop: '2px' },

  title: {
    fontFamily: '"Cinzel", serif', fontSize: '22px', fontWeight: '700',
    color: '#F5F0E8', marginTop: 0, marginBottom: '14px', lineHeight: '1.3',
  },
  body: {
    fontSize: '15px', color: 'rgba(245,240,232,0.65)',
    lineHeight: '1.7', marginBottom: '24px',
  },

  rewardBox: {
    background: 'rgba(201,146,10,0.12)', border: '1px solid rgba(201,146,10,0.3)',
    borderRadius: '12px', padding: '12px 20px', marginBottom: '24px',
  },
  rewardText: { fontSize: '14px', fontWeight: '700', color: '#C9920A' },

  shareBtn: {
    width: '100%', padding: '13px', background: 'transparent',
    border: '1px solid rgba(201,146,10,0.35)', borderRadius: '12px',
    fontSize: '14px', fontWeight: '600', color: '#C9920A',
    cursor: 'pointer', fontFamily: '"Lato", sans-serif', marginBottom: '10px',
  },
  dismissBtn: {
    width: '100%', padding: '14px', background: '#C9920A',
    border: 'none', borderRadius: '12px', fontSize: '15px',
    fontWeight: '700', color: '#0D0D2B', cursor: 'pointer',
    fontFamily: '"Lato", sans-serif',
  },
};
